import ciLogo from '../../assets/niq.png';
import "./layout.css";

const MobileTopbar = () => {
    return (
        <div
            className="header-block fixed-top bg-white border-bottom w-100"
            style={{
                height: 60,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '0 16px',
                zIndex: 1050
            }}
        >
            <img
                className="navbar-brand mobile-logo"
                src={ciLogo}
                alt="logo"
                style={{
                    cursor: 'pointer',
                    objectFit: 'contain',
                    height: '40px',
                    width: 'auto',
                    maxWidth: '220px',
                    display: 'block'
                }}
            />
        </div>
    );
};

export default MobileTopbar;
